import { Header } from '@containers/Header/Header'
import React from 'react'
import { DanknessContainer, StyledColumnLayoutWrapper } from './DoubleColumnLayout.styled'

interface Props {
  header: React.ReactNode
  headerKey?: string
  children: React.ReactNode
}

export const SingleColumnLayout: React.FC<Props> = ({ header, headerKey, children }) => {
  return (
    <DanknessContainer>
      <StyledColumnLayoutWrapper
        key={headerKey ?? (typeof header === 'string' ? header : undefined)}
        className="page-layout-wrapper"
      >
        <Header label={header} />
        <div style={{ flex: 1, minHeight: 0, margin: '1rem', marginTop: 0, overflow: 'hidden' }}>
          {children}
        </div>
      </StyledColumnLayoutWrapper>
    </DanknessContainer>
  )
}
